module.exports = __webpack_public_path__ + "img/s2P23.a3c7cfb8.png";